import { observer, useLocalObservable } from 'mobx-react-lite'
import React from 'react'
import { Alert } from 'shared/ui'
import { type IAgentHandoffNotifySettings } from 'entities/Chatbot'
import { HandoffNotifySettings } from 'entities/AIAgent/ui/HandoffNotifySettings/HandoffNotifySettings.tsx'
import { HandoffNotifySettingsStore } from 'entities/AIAgent/ui/HandoffNotifySettings/store/HandoffNotifySettingsStore.ts'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MessageModalActions } from 'widgets/TemplateActions/ui/MessageModalActions/MessageModalActions.tsx'
import styles from './styles.module.scss'

export type IHandoffToHumanContentProps = {
  onClose: () => void
  onSave: (data: IAgentHandoffNotifySettings) => void
  onDelete?: () => void
  data?: IAgentHandoffNotifySettings
  getData?: () => IAgentHandoffNotifySettings | undefined
}

export const HandoffToHumanContent = observer(
  ({ onClose, onSave, data, onDelete, getData }: IHandoffToHumanContentProps) => {
    const entities = useEntitiesContext()
    const store = useLocalObservable(
      () => new HandoffNotifySettingsStore(entities, data ?? getData?.())
    )

    const handleSave = () => {
      const validError = store.validate()
      if (validError) {
        return
      }
      onSave(store.notifySettings)
      onClose()
    }
    const handleDelete = onDelete
      ? () => {
          onDelete()
          onClose()
        }
      : undefined

    return (
      <>
        <div className={styles.content}>
          <HandoffNotifySettings store={store} />
          {store.error && (
            <Alert
              item={{
                type: 'error',
                desc: store.error,
              }}
            />
          )}
        </div>

        <MessageModalActions onDelete={handleDelete} onSave={handleSave} onCancel={onClose} />
      </>
    )
  }
)
